import { isValidMoneyValue } from "../is-valid-money";

const floatRegex = /^[-+]?(\d*\.\d+|\d+\.\d*|\d+)$/;

export function testFloatAndMoney(value: string) {
  if (!value) {
    return false; // If identifier is empty, return false
  }
  // Use parseFloat to cast the string to a number
  const numberValue = parseFloat(value);
  if (isNaN(numberValue)) {
    return false;
  }
  return isValidMoneyValue(value);
}

export function testPositiveFloat(value: string) {
  if (!value) {
    return false; // If identifier is empty, return false
  }
  // Use parseFloat to cast the string to a number
  const numberValue = parseFloat(value);
  if (isNaN(numberValue) || numberValue <= 0) {
    return false;
  }
  return true;
}

export function testPositiveFloatInclusiveZero(value: string) {
  if (!value) {
    return false; // If identifier is empty, return false
  }
  // Use parseFloat to cast the string to a number
  const numberValue = parseFloat(value);
  if (isNaN(numberValue) || numberValue < 0) {
    return false;
  }
  return true;
}

export function testFloat(value: string) {
  if (!value) {
    return false; // If identifier is empty, return false
  }
  // Use parseFloat to cast the string to a number
  const numberValue = parseFloat(value);
  if (isNaN(numberValue)) {
    return false;
  }
  return floatRegex.test(value);
}

export function testPositiveInteger(value: string) {
  if (!value) {
    return false; // If identifier is empty, return false
  }
  const numberValue = parseInt(value, 10);
  if (isNaN(numberValue) || numberValue <= 0) {
    return false;
  }
  return /^\d+$/.test(value);
}
